import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const EventCancelledPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [eventName, setEventName] = useState(location?.state?.eventName || 'このイベント');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { t } = useTranslation('eventCancelled');

  const canceledStatuses = new Set([
    'cancellation_pending_payment',
    'canceled',
    'refunding',
    'cancellation_completed',
    'cancellation_failed',
  ]);

  useEffect(() => {
    let active = true;

    const verify = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/events/${id}`);
        const event = res?.data?.event;
        const status = String(event?.cancellation_status || 'none');
        const eventPathId = event?.slug || id;

        if (!canceledStatuses.has(status)) {
          navigate(`/events/${eventPathId}`, { replace: true });
          return;
        }

        if (active) {
          setEventName(event?.name || 'このイベント');
        }
      } catch (e) {
        if (active) {
          setError(t('fetchFailed'));
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    if (id) {
      verify();
    } else {
      setLoading(false);
      setError(t('notFound'));
    }

    return () => {
      active = false;
    };
  }, [id, navigate]);

  if (loading) {
    return <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>{t('loading')}</div>;
  }

  if (error) {
    return <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>{error}</div>;
  }

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>{t('title')}</h1>
      <p style={{ marginBottom: '0.75rem' }}>{t('body', { name: eventName })}</p>
      <p style={{ marginBottom: '1.5rem', color: '#555' }}>
        {t('apology')}
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <Link to="/events">{t('toEventList')}</Link>
        <Link to="/">{t('toTop')}</Link>
      </div>
    </div>
  );
};

export default EventCancelledPage;
